module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"page.section.initial":"อะไหล่ตั้งต้น","page.section.optional":"อะไหล่เสริม","lot_part.field.mode":"ปรับค่าจาก Model","display.show_model_detail":"แสดงข้อมูลเปรียบเทียบอะไหล่กับ Model","button.manage_parts":"แก้ไขอะไหล่","part.field.has_serial_no":"Serial No"}}')
  delete Component.options._Ctor
}
